import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import cx from "classnames";

import styles from "./infinitescroll.module.scss";
import { Button } from "react-bootstrap";
import _ from "lodash";

export default function InfiniteScroll({ className, children, loading, hasMore, loadMore }) {
  const cardsData = useSelector((state) => _.get(state, "showcase.items", []));
  const pagination = useSelector((state) => _.get(state, "showcase.pagination", {}));

  const loadMoreItems = () => {
    if (!loading) {
      loadMore();
    }
  };

  return (
    <div className={cx(styles.infiniteScroll, className)}>
      {children}
      <div className={styles.loadMoreSec}>
        <p className={styles.assetCount}>
          {" "}
          Showing {cardsData.length} of {pagination.totalRecordsCount} assets{" "}
        </p>

        <div>
          {hasMore && loading && (
            <>
              <div className={cx(styles.loading)}>
                <video
                  className={styles.loaderMessageVideo}
                  loop
                  autoPlay
                  playsInline
                  muted >
                <source src="/images/Workspaceloader.webm" type="video/webm" />
              </video>
              </div>
            </>
          )}

          {hasMore && !loading && (
            <Button
              className={styles.loadMore}
              variant="outline"
              onClick={() => loadMoreItems()}>
              Load More
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
